module.exports = __webpack_public_path__ + "2e17515cdc99a7f97823eda0d4937463.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/TWS.jpg
// module id = 482
// module chunks = 0